import "./locales";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./App";
import "./index.css";
import "./firebase";

const root = createRoot(document.getElementById("root")!);

async function enableMocking() {
  const enabled = false;

  if (enabled) {
    const { worker } = await import("./msw/browser");
    return worker.start();
  }

  return Promise.resolve();
}

enableMocking().then(() => {
  root.render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
});
